import React, { useContext } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import classnames from 'classnames';

import { FilterModalContext } from './FilterModalContext';
import classes from './FilterModal.scss';

type Props = {
    title: string;
    flush?: boolean;
};

export const FilterModal: React.FC<React.PropsWithChildren<Props>> = ({ title, flush = false, children }) => {
    const { openerRef } = useContext(FilterModalContext);

    return (
        <Dialog.Portal>
            <Dialog.Overlay className={classes.overlay} />
            <Dialog.Content
                className={classnames(classes.content, { [classes.contentFlush]: flush })}
                data-smooth-scroll="FilterModal"
                aria-describedby={undefined}
                onCloseAutoFocus={(event) => {
                    event.preventDefault();
                    openerRef.current?.focus();
                }}
            >
                <Dialog.Title className={classes.title}>{title}</Dialog.Title>
                {children}
            </Dialog.Content>
        </Dialog.Portal>
    );
};
